import React from 'react';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '@components/PrimaryButton';
import { ModalLayout } from '@layouts';
import { useStyles, useStylesButton } from './styles';
import { initiateRefund, refundPayment } from '@api';
import { useOrderContext, useToastNotificationContext } from '../../../hooks';

const ConfirmRefundModal = ({
  open,
  handleClose,
  handleModalClose,
  refundedAmount,
  tipAmount,
  isTipChecked,
  refundItems,
  orderId,
  itemsCount,
}) => {
  const classes = useStyles();
  const classesButton = useStylesButton();
  const { t } = useTranslation('pointOfService');
  const { fetchOrderData } = useOrderContext();
  const { setToastNotification } = useToastNotificationContext();

  const singularOrPluralText = itemsCount === 1 ? 'item' : 'items';

  const handleRefund = async () => {
    await initiateRefund(orderId, refundItems);
    try {
      const response = await refundPayment(orderId, isTipChecked);
      if (response.error) {
        setToastNotification({
          isShowToast: true,
          toastType: 'error',
          toastMessage: response.error.message,
          toastKeyTranslate: 'Mislukt',
        });
      }
    } catch (e) {
      setToastNotification({
        isShowToast: true,
        toastType: 'error',
        toastMessage: 'Mislukt',
        toastKeyTranslate: 'Mislukt',
      });
    }
    await fetchOrderData({ orderId });

    handleModalClose(false);
  };
  const totalRefunds = isTipChecked
    ? refundedAmount + tipAmount
    : refundedAmount;

  return (
    <ModalLayout open={open} handleClose={handleClose}>
      <>
        <div className={classes.textPart}>
          {isTipChecked && itemsCount !== 0 ? (
            <p className={classes.suggestionRefund}>
              {t('areYouSureRefund')} {''}
              {itemsCount} {singularOrPluralText} {''}
              {isTipChecked && t('and tip ')}
              {t('totalValueRefund')}
            </p>
          ) : (
            <p className={classes.suggestionRefund}>
              {t('areYouSureRefundTheTip')} {t('totalValueRefund')}
            </p>
          )}
          <p className={classes.amountRefund}>
            {new Intl.NumberFormat('nl-NL', {
              style: 'currency',
              currency: 'EUR',
            }).format(totalRefunds)}
            ?
          </p>
        </div>
        <PrimaryButton
          text={t('buttons.confrimRefundButton')}
          classesButton={classesButton}
          handleClick={handleRefund}
        />
      </>
    </ModalLayout>
  );
};

export default ConfirmRefundModal;
